{
  "dss": {
    "footer": {
      "legalEntity": "STIHL VERTRIEBS AG, 8617 Mönchaltorf"
    },
    "link": {
      "contact": "https://support.stihl.com/fr-CH/websso-contact/",
      "faq": "https://support.stihl.com/fr-CH/externalkbsearchwebsso/"
    },
    "page": {
      "postPwSet": {
        "link_name": "Continuer à se connecter",
        "link_url": "/user/ui/"
      }
    }
  }
}
